import React, { FC } from 'react'
import * as yup from 'yup'
import { Button } from '@docpace/shared-react-components/Button'

import {
    useReactHookForm,
    UseReactHookFormProps,
} from '@docpace/shared-react-hooks/useReactHookForm'
import {
    MuiFormTranslationSelect,
} from '@docpace/shared-react-components/MuiFormTranslationSelect'
import { TranslationFragment } from '@docpace/shared-graphql/fragments'
import { TranslationType } from '@docpace/shared-ts-types'
import { FormSubmitControls } from '@docpace/shared-react-components'

export interface AdminUpdateItemTranslationFormProps
    extends Omit<UseReactHookFormProps, 'schema'> {
    name: string
    title: string
    translationType: TranslationType
    onCancel?: () => any
    translations: TranslationFragment[]
}

export const AdminUpdateItemTranslationForm: FC<
    AdminUpdateItemTranslationFormProps
> = (props) => {
    const {
        onCancel,
        translations,
        name,
        title,
        translationType,
        ...reactHookProps
    } = props
    const schema = {
        [name]: yup.string(),
    }
    const { FormWrapper, formController, submitError, doSubmit } =
        useReactHookForm({
            ...reactHookProps,
            schema,
        })

    const { getValues, setValue } = formController

    const filteredTranslations = translations.filter((tr)=>tr.translationType === translationType)

    return (
        <FormWrapper formComponentProps={{ autoComplete: 'off' }}>
            <MuiFormTranslationSelect
                translationType={translationType}
                translations={filteredTranslations}
                label={title}
                name={name}
            />
            <FormSubmitControls onCancel={onCancel} submitError={submitError} />
        </FormWrapper>
    )
}